export default function initDealersModal(): void {
  Alpine.data('dealersModal', () => ({
    showModal: false,
    dealerEmail: '',
    dealerName: '',
    dealerLogo: '',
    previousBodyOverflow: '',
    modalElement: null as HTMLElement | null,

    openModal(event: Event) {
      const button = event.currentTarget as HTMLElement;
      this.dealerEmail = button.dataset.dealerEmail ?? '';
      this.dealerName = button.dataset.dealerName ?? '';
      this.dealerLogo = button.dataset.dealerLogo ?? '';

      this.$nextTick(() => {
        // Update hidden fields in the form
        const form = document.querySelector<HTMLFormElement>('#dealer-form-container form');
        if (form) {
          const dealerEmailField = form.querySelector<HTMLInputElement>(
            'input[name="dealerEmail"]',
          );
          const dealerNameField = form.querySelector<HTMLInputElement>(
            'input[name="dealerName"]',
          );

          if (dealerEmailField) dealerEmailField.value = this.dealerEmail;
          if (dealerNameField) dealerNameField.value = this.dealerName;
        }
      });

      this.showModal = true;
      this.previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      this.$nextTick(() => {
        this.modalElement = document.querySelector<HTMLElement>('[data-x-show="showModal"]');
        if (this.modalElement) {
          this.modalElement.focus();
        }
        document.addEventListener('keydown', this.handleKeydown);
      });
    },

    closeModal() {
      this.showModal = false;
      document.body.style.overflow = this.previousBodyOverflow;
      // Accessibility: Remove Escape key handler
      document.removeEventListener('keydown', this.handleKeydown);
      // Accessibility: Restore focus if needed
      if (this.modalElement) {
        this.modalElement.blur();
        this.modalElement = null;
      }
    },

    handleKeydown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
      // Focus trapping (Tab/Shift+Tab)
      if (this.showModal && this.modalElement) {
        const focusable = this.modalElement.querySelectorAll<HTMLElement>(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        );
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }
    },
  }));
}
